module.exports = __webpack_public_path__ + "static/media/min_games.0e8d94a9.svg";